import { Injectable, signal } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class SelectedInsuredService {
  private readonly uuid = signal<string | null>(null)
  public readonly selectedUuid = this.uuid.asReadonly()

  public select(uuid: string): void {
    this.uuid.set(uuid)
  }

  public clear(): void {
    this.uuid.set(null)
  }
}
